module.exports = __webpack_public_path__ + "static/img/bac2.018f7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/bac2.png
// module id = 50RS
// module chunks = 2